const firebaseConfig = {
  apiKey: "AIzaSyCOsPqHoH3bWNLNIZf0gfZW3EIP17tY8pw",
  authDomain: "hydrorebates-78109.firebaseapp.com",
  databaseURL: "https://hydrorebates-78109.firebaseio.com",
  projectId: "hydrorebates-78109",
  storageBucket: "hydrorebates-78109.appspot.com",
  messagingSenderId: "301961301519",
  appId: "1:301961301519:web:67140a4c1703a42971dd7a"
};

// Cloud Functions
const backendUrl = `https://us-central1-${
  firebaseConfig.projectId
}.cloudfunctions.net/api/api`;

// App Engine
// const backendUrl = `<insert app engine url here>`;

export default {
  firebaseConfig,
  backendUrl,
};
